module.exports = __webpack_public_path__ + "img/4f_r_twodays.526b359d.jpg";